import {
  FETCH_ITEMS,
  FETCH_ITEMS_SUCCEED,
  FETCH_ITEMS_CANCEL,
  FETCH_ITEMS_FAILURE,
  START_FETCH_FEATURE_ITEMS_PAGE,
  WAIT_FETCH_FEATURE_ITEMS_PAGE,
  ABORT_WAIT_FETCH_FEATURE_ITEMS_PAGE
} from "../actions";

import imageData from "./imageData";
import { ImageMap } from "../imageMap.js";
import { ImageMap2018All } from "../imageMap2018All.js";
import { ImageMap2019All } from "../imageMap2019All.js";
import util from "../util.js";

const mappedImageData = {};

imageData.forEach(i => {
  const prefix = i.split("-")[0];
  mappedImageData[prefix] = mappedImageData[prefix] || [];
  mappedImageData[prefix].push(i);
});

const category = (state = { items: [] }, action) => {
  switch (action.type) {
    case FETCH_ITEMS:
      return {
        ...state,
        loading: true,
        waitingNextPage: false,
        endOfList: false
      };
    case FETCH_ITEMS_SUCCEED:
      const items = action.items.map(x => {
        if (x.category == "external") {
          return {
            ...x,
            images: x.images.map(util.makeS3URL)
          };
        } else {
          // IDからのルールでイメージURL設定
          const imagePrefix = x["order_id"].replace("-", "");
          const images = (() => {
            if (
              x.category.indexOf("general") == 0 ||
              x["order_id"].indexOf("218") == 0 ||
              x["order_id"].indexOf("219") == 0
            ) {
              return [`/data/img-general/${x["order_id"]}.jpg`];
            } else if (x.category.indexOf("2019") != -1) {
              return (
                (ImageMap2019All[x["order_id"]] || []).map(
                  x => `/data/img-2019/${x}`
                ) || []
              );
            } else if (x.category.indexOf("2018") != -1) {
              return (
                (ImageMap2018All[x["order_id"]] || []).map(
                  x => `/data/img-2018/${x}`
                ) || []
              );
            } else if (x.category.indexOf("2017") != -1) {
              return (
                (ImageMap[x["order_id"]] || []).map(
                  x => `/data/img-2017/${x}`
                ) || []
              );
            }
            return (
              (mappedImageData[imagePrefix] || []).map(x => `/data/img/${x}`) ||
              []
            );
          })().map(util.makeS3URL);
          return {
            ...x,
            images
          };
        }
      });
      return {
        ...state,
        items: action.append ? [...state.items, ...items] : items,
        loading: false,
        lastQuery: action.query
      };
    case FETCH_ITEMS_CANCEL:
      return { ...state, loading: false };
    case FETCH_ITEMS_FAILURE:
      return {
        items: [],
        loading: false,
        error: action.error
      };
    case START_FETCH_FEATURE_ITEMS_PAGE:
      return {
        ...state,
        loading: true,
        waitingNextPage: false,
        endOfList: false
      };
    case WAIT_FETCH_FEATURE_ITEMS_PAGE:
      return {
        ...state,
        waitingNextPage: true
      };
    case ABORT_WAIT_FETCH_FEATURE_ITEMS_PAGE:
      return {
        ...state,
        waitingNextPage: false,
        endOfList: true
      };
    default:
      return state;
  }
};

export default category;



// WEBPACK FOOTER //
// ./src/reducers/category.js